import { useAppContext } from "@/context/AppContext";
import { useAuthContext } from "@/context/AuthContext";
import { ReactNode } from "react";

export default function DevLoginButtons() {
  const { devLoginError } = useAppContext();

  return (
    <div className="flex flex-col gap-2 w-full">
      <DevLoginButton email={"jeanpetit@wiswiz.nl"}>
        Jean Petit (nieuwe user)
      </DevLoginButton>

      <DevLoginButton email={"janpieter@gmaiil.com"}>
        Jan Pieter (unlimited access)
      </DevLoginButton>

      <DevLoginButton email={"karelmetlangemailadres@gmailoutlook.com"}>
        Karel Euler (trial expired)
      </DevLoginButton>

      <DevLoginButton email={"blaisepascal@h0tmail.com"}>
        Blaise Pascal (organization member)
      </DevLoginButton>

      <DevLoginButton email={"katherinejohnson@pr0t0n.me"}>
        Katherine Johnson (parent)
      </DevLoginButton>

      <DevLoginButton email={"satyendra@micros0ft.com"}>
        Satyendra (parent)
      </DevLoginButton>

      {devLoginError && (
        <div className="flex items-center justify-center gap-2 text-red-600">
          <div>Error: </div>
          <div>{devLoginError}</div>
        </div>
      )}
    </div>
  );
}

function DevLoginButton({
  email,
  children
}: {
  email: string;
  children: ReactNode;
}) {
  const { devLogin } = useAuthContext();

  return (
    <button
      onClick={() => devLogin(email)}
      className="rounded shadow p-4 bg-amber-500 w-full text-sm"
    >
      {children}
    </button>
  );
}
